import { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import store from '~/store';
import { getSelectedTabPermission } from '~/store/modules/tabs/selectors';
import { useAuthStore } from '~/store/modules/auth/useAuthStore';
import axios from 'axios';

// #FIXME
// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
const changeLoading = (status: any) => { };

export default {
  onResponse: async (responseParam: AxiosResponse<any>) => {
    changeLoading('idle');
    return responseParam;
  },
  onRequest: async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
    if (config?.headers) {
      if (!config.url?.includes('/connect/token')) {
        config.headers.Authorization = useAuthStore.getTokenToHeader();
      }

      const permissionName = getSelectedTabPermission(store.getState());
      if (permissionName) {
        config.headers['Permission-Name'] = permissionName;
      }
    }

    return config;
  },
  onRequestStatus: (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    if (config?.headers) {
      config.headers.Authorization = useAuthStore.getTokenToHeader();
    }
    return config;
  },
  onResponseApiSession: async (responseParam: AxiosResponse<any>) => {
    changeLoading('idle');
    return responseParam;
  },
  onError: async (error: any) => {
    changeLoading('idle');

    try {
      return await useAuthStore.handleAxiosError(error, axios);
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
